import * as Blockly from 'blockly/core';
import { expr } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['millis'] = function (block: Blockly.Block): [string, number] {
        const unit = block.getFieldValue('OP') as string;
        const code = unit === 's' ? 'millis() / 1000.0' : 'millis()';
        return expr(code);
    };
}
